import PropTypes from "prop-types";
import React from "react";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import ArrowIcon from "@mui/icons-material/ArrowRightAlt";
import { useTranslation } from "react-i18next";

const allQuestionsPerPage = "all";

const useStyles = makeStyles(theme => ({
  arrowLeft: {
    transform: "rotate(180deg)"
  }
}));

const CourseQuizNavigationButtons = ({
  quizSubmitted,
  numQuestions,
  questionsPerPage,
  currentPage,
  onChangePage,
  quizType,
  onSubmitQuiz
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const numPerPage =
    questionsPerPage === allQuestionsPerPage || !questionsPerPage
      ? allQuestionsPerPage
      : parseInt(questionsPerPage);
  const showPrevBtn = currentPage !== 0;
  const showNextBtn =
    numPerPage === allQuestionsPerPage
      ? false
      : currentPage + 1 !== Math.ceil(numQuestions / numPerPage);
  const showSubmitBtn = !quizSubmitted && !showNextBtn;

  return (
    <>
      {showPrevBtn && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => onChangePage(currentPage - 1)}
          startIcon={
            <ArrowIcon className={classes.arrowLeft} fontSize="large" />
          }
          data-qa="course-quiz-navigation-buttons-prev"
        >
          {numPerPage === 1
            ? t("courseQuiz.prevQuestionPageBtn")
            : t("courseQuiz.prevQuestionsPageBtn")}
        </Button>
      )}
      {showNextBtn && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => onChangePage(currentPage + 1)}
          endIcon={<ArrowIcon fontSize="large" />}
          data-qa="course-quiz-navigation-buttons-next"
        >
          {numPerPage === 1
            ? t("courseQuiz.nextQuestionPageBtn")
            : t("courseQuiz.nextQuestionsPageBtn")}
        </Button>
      )}
      {showSubmitBtn && (
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmitQuiz}
          data-qa="course-quiz-navigation-buttons-submit"
        >
          {t("contentViewer.navigationButtons.submit")} {quizType}
        </Button>
      )}
    </>
  );
};

CourseQuizNavigationButtons.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The question ID
       */
      id: PropTypes.number,
      /**
       * The question number
       */
      order: PropTypes.number,
      /**
       * The question text
       */
      text: PropTypes.string,
      /**
       * The amount of points the question is worth
       */
      points: PropTypes.number,
      answerChoices: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The answer text
           */
          text: PropTypes.string
        })
      ),
      matchClues: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The match clue text
           */
          text: PropTypes.string,
          position: PropTypes.number
        })
      ),
      matchChoices: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The match clue text
           */
          text: PropTypes.string,
          position: PropTypes.number
        })
      )
    })
  ),
  learnerAnswers: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        id: PropTypes.number,
        /**
         * The question id
         */
        questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        /**
         * The answer choice id
         */
        answerData: PropTypes.any
      }),
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          /**
           * The question id
           */
          questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          /**
           * The answer choice id
           */
          answerData: PropTypes.any
        })
      )
    ])
  ),
  submitted: PropTypes.bool,
  showModal: PropTypes.func,
  userAssignmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default CourseQuizNavigationButtons;
